import { ANIMATE } from '@namespace/top/animate'
// import { VIDEO } from '@namespace/top/video'

export default function top() {
  window.addEventListener('load', () => {
    ANIMATE.init()
    // VIDEO.init()
  })
}
